import { render, staticRenderFns } from "./ModalClient.vue?vue&type=template&id=7816e0f0&scoped=true&"
import script from "./ModalClient.vue?vue&type=script&lang=js&"
export * from "./ModalClient.vue?vue&type=script&lang=js&"
import style0 from "./ModalClient.vue?vue&type=style&index=0&id=7816e0f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7816e0f0",
  null
  
)

export default component.exports